import {useCallback, useEffect, useState} from 'react';

interface RoadmapNodeExpansionState {
  contextKey: string | null;
  collapsedNodeKeys: ReadonlySet<string>;
}

const EMPTY_COLLAPSED_NODE_KEYS: ReadonlySet<string> = new Set();

export const useRoadmapNodeExpansion = (contextKey: string | null) => {
  const [state, setState] = useState<RoadmapNodeExpansionState>(() => ({
    contextKey,
    collapsedNodeKeys: EMPTY_COLLAPSED_NODE_KEYS,
  }));
  const collapsedNodes =
    state.contextKey === contextKey ? state.collapsedNodeKeys : EMPTY_COLLAPSED_NODE_KEYS;

  useEffect(() => {
    setState((current) =>
      current.contextKey === contextKey
        ? current
        : {contextKey, collapsedNodeKeys: EMPTY_COLLAPSED_NODE_KEYS}
    );
  }, [contextKey]);

  const toggleNode = useCallback(
    (nodeKey: string) => {
      setState((current) => {
        const collapsedNodeKeys = new Set(
          current.contextKey === contextKey ? current.collapsedNodeKeys : []
        );
        if (collapsedNodeKeys.has(nodeKey)) {
          collapsedNodeKeys.delete(nodeKey);
        } else {
          collapsedNodeKeys.add(nodeKey);
        }
        return {contextKey, collapsedNodeKeys};
      });
    },
    [contextKey]
  );

  return {collapsedNodes, toggleNode};
};
